import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AccSessionSurveysResponse } from '@interfaces';
import { AppService } from '../../../../../../services';
import { DeliveryAreaService } from '../../../../delivery-area.service';
import { DeliveryOverviewService } from '../../../delivery-overview.service';
import { getSetup } from './grid/get-setup';

export interface SessionFeedback extends AccSessionSurveysResponse {
	accName: string,
	programfacilitatorName: string,
	eventStartUTC: number,
	entrepreneurName: string,
}

@Component({
	selector: 'delivery-session-feedback-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './session-feedback-view.part.html',
})
export class DeliverySessionFeedbackViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly pageService = inject(DeliveryOverviewService);
	private readonly areaService = inject(DeliveryAreaService);

	public setup = computed(() => getSetup(this.util, this.areaService));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public sessionFeedbacks = computed<SessionFeedback[]>(() => {
		const data = this.areaService.deliveryData();
		if (!data) return [];

		const eventById = this.util.array.toMap(data.events, e => e.eventId);
		const accById = this.util.array.toMap(data.accelerators, acc => acc.accId);
		const entByPersonId = this.util.array.toMap(data.allVentures.flatMap(v => v.entrepreneurs), ent => ent.personId);


		return data.accSurveysResponses.map(survey => {

			const event = eventById[survey.eventId]!;
			const acc = accById[survey.accId]!;

			return {
				...survey,
				accName: acc.name,
				programfacilitatorName: this.app.getStaffNameById(acc.facilitatorStaffId) ?? '',
				eventStartUTC: event.startUTC,
				entrepreneurName: entByPersonId[survey.entrepreneurPersonId]?.name ?? '',
			}
		});

	});
}